const setResumeSkills = (skills) => ({
    type: 'SET_RESUME_SKILLS',
    skills,
});

export default setResumeSkills;
